import React from 'react';
import GridImage from './GridImage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const AuTateProjectGrid = (props) => {
    let currentProjectIndex = props.projects.findIndex(project => project.path === props.path);
    let gridImages = props.projects[currentProjectIndex].gridImages;
    return (
        <div>
            <div className="project-slide"></div>
            <div className="project-grid au-tate-project container">
                <div className="flex">
                    {/*<img className="grid-img-1" src="/assets/img/homes/au-tate/02.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-1', asset: gridImages[1], sizes: '66.66666667%'}}/>
                    <div className="grid-col-1">
                        <svg className="grid-svg-1" x="0px" y="0px" width="188" height="470" viewBox="0 0 188 470">
                            <text className="tate-text" x="0" y="10" fill="#000">
                                <tspan x="0" className="barlow-it">au tate</tspan>
                                
                                <tspan x="0" dy="20" className="barlow-it">a</tspan>
                                <tspan x="0" dx="121" className="barlow-it">a</tspan>
                                <tspan x="0" dy="40" className="barlow-it">a</tspan>
                                <tspan x="0" dx="121" className="barlow-it">a</tspan>
                                <tspan x="0" dy="68" className="barlow-it">a</tspan>
                                <tspan x="0" dx="121" className="barlow-it">a</tspan>
                                <tspan x="0" dy="30" className="barlow-it">a</tspan>
                                <tspan x="0" dx="121" className="barlow-it">a</tspan>
                                <tspan x="0" dy="80" className="barlow-it">a</tspan>
                                <tspan x="0" dx="121" className="barlow-it">a</tspan>
                                <tspan x="0" dy="139" className="barlow-it">a</tspan>
                                <tspan x="0" dx="121" className="barlow-it">a</tspan>
                                <tspan x="0" dy="24" className="barlow-it">a</tspan>
                                <tspan x="0" dx="121" className="barlow-it">a</tspan>
                                
                                <tspan x="0" dy="59" className="barlow-se-bo-it">a</tspan>
                                <tspan x="0" dx="121" className="barlow-se-bo-it">a</tspan>
                            </text>
                        </svg>
                        {/*<img className="grid-img-3" src="/assets/img/homes/au-tate/03.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-3', asset: gridImages[2], sizes: ''}}/>
                    </div>
                </div>
                {/*<img className="grid-img-2" src="/assets/img/homes/au-tate/04.jpg" alt=""/>*/}
                <GridImage params={{className: 'grid-img-2', asset: gridImages[3], sizes: ''}}/>
                <svg className="grid-svg-2" x="0px" y="0px" width="796" height="9" viewBox="0 0 796 9">
                    <text className="tate-text2 barlow-it" x="0" y="8" fill="#000" textLength="796">
                        aaaAAUAEEeeee
                    </text>
                </svg>
                <div className="flex flex-container-1">
                    <svg className="grid-svg-3" x="0px" y="0px" width="7" height="473" viewBox="0 0 7 473">
                        <text className="tate-text2 barlow-it" x="0" y="10" fill="#000">
                            <tspan x="0">t</tspan>
                            <tspan x="0" dy="66">t</tspan>
                            <tspan x="0" dy="66">T</tspan>
                            <tspan x="0" dy="66">T</tspan>
                            <tspan x="0" dy="66">T</tspan>
                            <tspan x="0" dy="66">t</tspan>
                            <tspan x="0" dy="66">t</tspan>
                            <tspan x="0" dy="66">t</tspan>
                        </text>
                    </svg>
                    {/*<img className="grid-img-4" src="/assets/img/homes/au-tate/05.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-4', asset: gridImages[4], sizes: ''}}/>
                </div>
                {/*<img className="grid-img-5" src="/assets/img/homes/au-tate/06.jpg" alt=""/>*/}
                <GridImage params={{className: 'grid-img-5', asset: gridImages[5], sizes: ''}}/>
                <div className="flex">
                    <div className="grid-col-2">
                        <svg className="grid-svg-4" x="0px" y="0px" width="224" height="355" viewBox="0 0 224 355">
                            <text className="tate-text3 barlow-it" x="0" y="7" fill="#575757" textLength="1008">
                                <tspan x="0">atat</tspan>
                                <tspan x="0" dy="116">uaua</tspan>
                                <tspan x="0" dx="73" dy="116">t</tspan>
                                <tspan x="0" dx="217">t</tspan>
                                <tspan x="0" dx="73" dy="116">e</tspan>
                                <tspan x="0" dx="109">e</tspan>
                                <tspan x="0" dx="145">e</tspan>
                                <tspan x="0" dx="181">e</tspan>
                                <tspan x="0" dx="217">e</tspan>
                            </text>
                        </svg>
                        {/*<img className="grid-img-6" src="/assets/img/homes/au-tate/08.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-6', asset: gridImages[7], sizes: ''}}/>
                    </div>
                    {/*<img className="grid-img-7" src="/assets/img/homes/au-tate/07.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-7', asset: gridImages[6], sizes: ''}}/>
                </div>
                <div className="flex credits-container">
                    <div className="credits desktop">
                        <span className="credits-title red">Credits</span>
                        <ul className="no-style">
                            <li><span className="red barlow-me">Project</span> Pendant ce temps, Au Tate</li>
                            <li><span className="red barlow-me">Photographer</span> Olivier Foulon</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

// export default AuTateProjectGrid;
const mapStateToProps = (state) => {
    return {
        projects: state.assets.projects
    };
};

export default withRouter(connect(mapStateToProps, null)(AuTateProjectGrid));


// WEBPACK FOOTER //
// ./src/components/AuTateProjectGrid.js